import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ChiSiamo } from "@/components/ChiSiamo";
import { Progetto } from "@/components/Progetto";
import { GiornataTipo } from "@/components/GiornataTipo";
import { Gallery } from "@/components/Gallery";
import { Iscrizioni } from "@/components/Iscrizioni";
import { RichiediInfo } from "@/components/RichiediInfo";
import { Calendario } from "@/components/Calendario";
import { Contatti } from "@/components/Contatti";
import { CTABanner, Footer } from "@/components/Footer";
import { ConsentManager } from "@/components/ConsentManager";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";

function Home() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [location]);

  return (
    <div className="App font-body text-slate-800 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <ChiSiamo />
        <Progetto />
        <GiornataTipo />
        <Gallery />
        <Iscrizioni />
        <RichiediInfo />
        <Calendario />
        <Contatti />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>
      <ConsentManager />
    </>
  );
}

export default App;
